'use client';

import { createContext, useContext } from 'react';

interface MenuSingleSelectGroupContextValue {
  readonly value?: string;
  readonly isDisabled: boolean;
}

const MenuSingleSelectGroupContext =
  createContext<MenuSingleSelectGroupContextValue | null>(null);

MenuSingleSelectGroupContext.displayName = 'MenuSingleSelectGroupContext';

function useMenuSingleSelectGroupContext() {
  return useContext(MenuSingleSelectGroupContext);
}

export { MenuSingleSelectGroupContext, useMenuSingleSelectGroupContext };
